module.exports = __webpack_public_path__ + "img/register-logo.2020454c.png";